export enum GroupingDateInterval {
    DAILY       = 'daily',
    WEEKLY      = 'weekly',
    BIWEEKLY    = 'biweekly',
    MONTHLY     = 'monthly',
    QUARTERLY   = 'quarterly',
    YEARLY      = 'yearly',
}